import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import data from './data';
import address from 'src/services/member-auth/redux/address';
import member from 'src/services/member-auth/redux';
import navSlice from './navSlice';

const store = configureStore({
  reducer: {
    data,
    member: member,
    address: address,
    navData: navSlice
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
const useAppDispatch: () => AppDispatch = useDispatch;

export { store, useAppDispatch, useAppSelector };
